import { fetcher } from "@/src/shared/api/fetcher";

import type { DetectCountryResponse } from "./types";

export const detectCountry = () =>
  fetcher<DetectCountryResponse>(
    "/api/detect-country"
  );